import styled from 'styled-components';

const QtyWrapper = styled.div`
  width: fit-content;
  margin-bottom: 5px;
  height: 27px;
`;

export { QtyWrapper };
